import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TableToolbar from "../../../common_components/TableToolbar";
import AppButton from "../../../common_components/AppButton";
import PagesCommonHeader from "../../../common_components/PagesCommonHeader";
import CommonTabs from "../../../common_components/CommonTabs";
import { useSelector } from "react-redux";
import AddEditClientDrawer from "../AddEditDrawer/AddEditClientDrawer";
import { selectCanManageClients } from "../../../redux/authSlice";
const ClientListControls = ({ status, setStatus, searchText, setSearchText, setPage, refetchClientList }) => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const counts = useSelector((s) => s.clientData.counts);
    const canManageClients = useSelector((s) => selectCanManageClients(s));
    /* ===== DEBOUNCE SEARCH ===== */
    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedSearch(searchText);
            setPage(1);
        }, 300);
        return () => clearTimeout(t);
    }, [searchText, setPage]);
    /* ===== LEFT SECTION (TABS) ===== */
    const leftSection = (_jsx(CommonTabs, { selectedValue: status, onChange: (val) => { setStatus(val); setPage(1); }, tabs: [
            {
                value: 'active',
                label: (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [_jsx(Box, { sx: { width: 8, height: 8, borderRadius: "50%", background: status === "active" ? "#12B76A" : "#98A2B3" } }), "Active (", counts.active, " Client)"] }))
            },
            {
                value: 'inactive',
                label: (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' }, children: [_jsx(Box, { sx: { width: 8, height: 8, borderRadius: "50%", background: status === "inactive" ? "#667085" : "#98A2B3" } }), "Inactive (", counts.inactive, " Client)"] }))
            }
        ] }));
    /* ===== RIGHT SECTION ===== */
    const rightSection = (_jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [_jsx(Box, { width: 320, children: _jsx(TableToolbar, { showFullScreen: true, showSearch: true, title: "", searchValue: searchText, onSearchChange: setSearchText }) }), canManageClients && (_jsx(AppButton, { variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: () => setOpenDrawer(true), sx: {
                    height: 40,
                    px: 2,
                    borderRadius: 2,
                    textTransform: "none",
                    border: "1px solid #A3005C"
                }, className: "all-Font-Sizes", children: "Add Client" }))] }));
    return (_jsxs(_Fragment, { children: [_jsx(PagesCommonHeader, { height: "65px", lastUpdatedSection: leftSection, rightSection: rightSection }), _jsx(AddEditClientDrawer, { open: openDrawer, mode: "create", onClose: () => setOpenDrawer(false), onSuccess: refetchClientList, status: status })] }));
};
export default ClientListControls;
